import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

// /auth layout: handles legacy ?path= redirects for the exact /auth path,
// and renders child routes (e.g. /auth/verify) without redirecting.
export const Route = createFileRoute("/auth")({
  beforeLoad: ({ location, search }) => {
    if (location.pathname !== "/auth") return;
    const legacy = (search as any)?.path as string | undefined;
    if (legacy === "signin") {
      throw redirect({ to: "/signin" });
    }
    if (legacy === "signup") {
      throw redirect({ to: "/register" });
    }
    throw redirect({ to: "/signin" });
  },
  component: () => <Outlet />,
});
